<template>
<!-- <div class="step">
<div v-for="(item, i) in heading" :key="i" class="stepp">
    <div class="stepper">
        <div :class="{ 'circle-active': i <= current, 'circle-inactive': i > current}"></div>
        <hr :class="{ 'active': i < current, 'inactive': i >= current}" >
    </div>
    <div class="stepperheading">
        <div :class="{'headactive': i == current, 'headcomplete': i <current}">{{item}}</div>
    </div>
</div>
</div> -->

<div>
  <div class="flex-container">
  <ul class="stepper">
  	<li v-for="(item, i) in heading" :key="i" class="stepp" :class="{ 'active': i < current, 'inactive': i >= current}">
    	  <div class="circle" :class="{ 'active': i <= current, 'inactive': i > current}" @click="currentStep(i)"></div>
        <p :class="{'headactive': i == current, 'headcomplete': i <current}" @click="currentStep(i)">{{item}}</p>
    </li>
  </ul>
</div>
</div>
</template>

<script>
export default {
  props: {
    heading: {
     type: Array
    },
    current: {
      type: Number
    }
  },
  watch: {
    current:function(oldval, newval){
      this.$nextTick(() => {
        // //console.log('current comp watcher', newval)
        return newval
      })
    }
  },
  methods: {
    currentStep(currentVal) {
      this.$emit('currentStepper', currentVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  justify-content: center;
}

.stepper{
	  list-style:none;

    margin:0px;
    padding:0px;
    display: flex;
    position:relative;
    flex-grow: 1;
    flex-basis: 0;
    li{
      margin: 8px;
      cursor: pointer;
      align-items: center;
      position:relative;
      text-align:center;
      flex-grow: 1;
      flex-basis: 0;

        p{
          margin-top:10px;
        }
        .circle{
          width:20px;
          height:20px;
          background-color:#d8d8d8;
          border-radius:50%;
          display: inline-block;
          vertical-align: middle;
          &.active{
            background-color: #34c0be;
            border-radius: 50%;
          }
           &.inactive {
            background-color: #d8d8d8;
            border-radius: 50%;
          }
        }
        &:not(:last-child)::after{
          content: '';
          position: absolute;
          border-bottom: 2px solid #d8d8d8;
          margin-left: 10px;
          width: 100%;
          left: 50%;
          top: 10px;
          z-index: 0;
        }
        &.active{
          &::after{
             border-bottom: 2px solid #34c0be;
          }
        }
    }
}





/* .step{
    display: flex;
    justify-content: space-between;
}
.stepp {
  flex-grow: 1;
}
.stepper{
    display:flex;
    align-items: center;
} */
// .active{
//   background-color: #34c0be;
//   border-color: #34c0be;
//   border-style: solid;
//   height: 2px;
//   width: 100%
// }
// .inactive{
//   background-color:#d8d8d8;
//   border-color:#d8d8d8;
//   border-style: solid;
//   height: 2px;
//   width: 100%
// }

.stepperheading {
    display: flex;
    width: 104%;
    justify-content: space-between;
    margin-top: 7px;
}
.headactive {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #303030;
}
.headcomplete{

  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #34c0be;
}
</style>
